import script from "./Team.vue?vue&type=script&setup=true&lang=js"
export * from "./Team.vue?vue&type=script&setup=true&lang=js"

import "./Team.vue?vue&type=style&index=0&id=c6f5aba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6f5aba8"]])

export default __exports__